module.exports = __webpack_public_path__ + "img/bannerVoucher.d47aed59.png";